export const isDataLoading = (state) => state.dataLoader.loading;